// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type=checkbox] {
  margin-right: 5px;
}

:host {
  color: white;
  cursor: pointer;
}
:host label {
  display: flex;
  padding: 4px 10px;
  margin: 0;
  cursor: inherit;
  min-width: 120px;
  align-items: center;
}
:host span {
  color: inherit;
  cursor: inherit;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/content/layout/components/instantsearch/instantsearch-toggle/instantsearch-toggle.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;AACF;AACE;EACE,aAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AAEE;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAAJ","sourcesContent":["input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n\n:host {\n  color: white;\n  cursor: pointer;\n\n  label {\n    display: flex;\n    padding: 4px 10px;\n    margin: 0;\n    cursor: inherit;\n    min-width: 120px;\n    align-items: center;\n  }\n\n  span {\n    color: inherit;\n    cursor: inherit;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
